import { withDefaultProps } from '@chakra-ui/react';
import { Button } from './components/button';
import { styles } from './styles';
import { colors } from './foundations/colors';
import { FormLabel } from './components/formLabel';
import { Input } from './components/input';
import { fontFace } from './fontFace';
import { fonts } from './foundations/fonts';
import { Breadcrumb } from './components/breadcrumb';
import { Checkbox } from './components/checkbox';
import { Container } from './components/container';
import { Select } from './components/select';
import { fontSizes } from './foundations/fontSizes';
import { sizes } from './foundations/sizes';
import { Footer } from './customComponents/footer';
import { SideNav } from './customComponents/sideNav';

export default [
  {
    components: {
      Container,
      Button,
      FormLabel,
      Input,
      Select,
      Breadcrumb,
      Checkbox,
      Footer,
      SideNav,
    },
    fonts,
    colors,
    fontFace,
    fontSizes,
    sizes,
    styles,
    config: { cssVarPrefix: 'bc' },
  },
  withDefaultProps({
    defaultProps: {
      size: 'sm',
      variant: 'filled',
    },
    components: ['Input', 'NumberInput', 'PinInput', 'Select', 'Textarea'],
  }),
];
